import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useEffect, useState } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import { Pagination, Navigation, Autoplay } from 'swiper';
import Product from '../Types/Product';
import clsx from 'clsx';
import ProductBlockNoSlider from './ProductBlockNoSlider';

interface ProductSliderProps {
  products: Product[];
  title: string;
  footerLinkText: string;
  footerLinkUrl: string;
  numPerRow?: number;
  showBuyButton?: boolean;
}

const ProductSlider = ({
  products,
  title,
  footerLinkText,
  footerLinkUrl,
  numPerRow = 5,
  showBuyButton,
}: ProductSliderProps) => {
  const [renderSlider, setRenderSlider] = useState(false);

  useEffect(() => setRenderSlider(true), []);

  return renderSlider ? (
    <>
      {title && (
        <div className="flex justify-between mb-6 relative z-10">
          <h2 className="leading-tight uppercase">{title}</h2>
          {footerLinkText && footerLinkUrl && (
            <button
              onClick={() => (window.location.href = footerLinkUrl)}
              className="btn btn--medium btn--gray-border"
            >
              {footerLinkText}
            </button>
          )}
        </div>
      )}
      <Swiper
        className={clsx(
          'sm-down:!-mx-4 md-only:!-mx-6 [&_.swiper-pagination-bullet]:rounded-none [&_.swiper-pagination]:h-auto [&_.swiper-pagination]:bottom-0 [&_.swiper-slide]:h-auto [&_.swiper-wrapper]:pb-[45px] [&_.swiper-pagination-bullet]:bg-gray-400 [&_.swiper-pagination-bullet]:w-6 [&_.swiper-pagination-bullet]:h-[6px] [&_.swiper-pagination-bullet]:opacity-100 [&_.swiper-pagination-bullet.swiper-pagination-bullet-active]:bg-gray-900',
          '[&_.swiper-button-prev]:!left-0 [&_.swiper-button-prev]:rounded-[0_4px_4px_0] [&_.swiper-button-prev]:hidden [&_.swiper-button-prev]:bg-gray-100 [&_.swiper-button-prev]:w-12 [&_.swiper-button-prev]:h-12 [&_.swiper-button-prev]:top-[calc(50%_-_24px)] [&_.swiper-button-prev]:lg:flex [&_.swiper-button-prev:after]:text-lg [&_.swiper-button-prev:after]:text-black',
          '[&_.swiper-button-next]:!right-0 [&_.swiper-button-next]:rounded-[4px_0_0_4px] [&_.swiper-button-next]:hidden [&_.swiper-button-next]:bg-gray-100 [&_.swiper-button-next]:w-12 [&_.swiper-button-next]:h-12 [&_.swiper-button-next]:top-[calc(50%_-_24px)] [&_.swiper-button-next]:lg:flex [&_.swiper-button-next:after]:text-lg [&_.swiper-button-next:after]:text-black'
        )}
        spaceBetween={4}
        slidesPerView={2.2}
        slidesPerGroup={2}
        pagination={true}
        navigation={true}
        loop={false}
        modules={[Pagination, Navigation, Autoplay]}
        autoplay={{ delay: 7000 }}
        breakpoints={{
          767: { spaceBetween: 4, slidesPerView: 4, slidesPerGroup: 4 },
          1023: { slidesPerView: numPerRow, slidesPerGroup: numPerRow },
        }}
        simulateTouch={!showBuyButton}
      >
        {products.map((product, idx) => (
          <SwiperSlide key={product.id + 'slide' + idx}>
            <ProductCard product={product} showBuyButton={showBuyButton} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  ) : (
    //Render product block without slider on server to avoid layout shifting
    <div>
      <ProductBlockNoSlider
        products={products.slice(0, 5)}
        numPerRow={5}
      />
    </div>
  );
};

export default ProductSlider;
